import { S2FontFamily } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { FontWeight } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { LgTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { MdTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { SmTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { TextColor } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { TextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { XlTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { XxlTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { XxxlTextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import React from 'react';
import cn from 'classnames';

export type HeadingProps = Omit<TextProps, 'tagName'> & {
  level: 1 | 2 | 3 | 4;
};

export type TextSizeProps = {
  disableAutoResponsive?: boolean;
  textSize?: TextSize;
  smTextSize?: SmTextSize;
  mdTextSize?: MdTextSize;
  lgTextSize?: LgTextSize;
  xlTextSize?: XlTextSize;
  xxlTextSize?: XxlTextSize;
  xxxlTextSize?: XxxlTextSize;
};

export type TextProps = {
  tagName: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'p' | 'span';
  textColor?: TextColor;
  fontFamily?: S2FontFamily;
  fontWeight?: FontWeight;
} & TextSizeProps &
  React.HTMLAttributes<HTMLElement>;

export const anyResponsiveSizesProvided = (props: TextSizeProps): boolean => {
  const {
    textSize,
    smTextSize,
    mdTextSize,
    lgTextSize,
    xlTextSize,
    xxlTextSize,
    xxxlTextSize,
  } = props;

  return (
    !!textSize &&
    (!!smTextSize ||
      !!mdTextSize ||
      !!lgTextSize ||
      !!xlTextSize ||
      !!xxlTextSize ||
      !!xxxlTextSize)
  );
};

export const computeClassNamesForTextSize = (props: TextSizeProps): string => {
  const {
    disableAutoResponsive,
    textSize,
    smTextSize,
    mdTextSize,
    lgTextSize,
    xlTextSize,
    xxlTextSize,
    xxxlTextSize,
  } = props;

  if (disableAutoResponsive) {
    return textSize ?? 'text-base';
  }

  // We should also act as if we are non-responsive if there is more than one text size provided.
  if (anyResponsiveSizesProvided(props)) {
    return cn(
      textSize,
      smTextSize,
      mdTextSize,
      lgTextSize,
      xlTextSize,
      xxlTextSize,
      xxxlTextSize,
    );
  }

  // Using the text size provided, map ourselves to a responsive set that incorporates the tailwind breakpoints.
  const responsiveMap: Record<TextSize, string> = {
    'text-xs': 'text-xs',
    'text-sm': 'text-sm',
    'text-md': 'text-md',
    'text-base': 'text-sm lg:text-base',
    'text-lg': 'text-base xl:text-lg',
    'text-xl': 'text-lg lg:text-xl',
    'text-2xl': 'text-xl xl:text-2xl',
    'text-3xl': 'text-xl xl:text-3xl',
    'text-4xl': 'text-xl xl:text-2xl 2xl:text-3xl 3xl:text-4xl',
  };

  return responsiveMap[textSize ?? 'text-base'];
};
